import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { LoginDialog } from '../components/Auth/LoginDialog';

const LoginPage: React.FC = () => {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
      <Paper sx={{ p: 3, maxWidth: 400, width: '100%' }} elevation={3}>
        <Typography variant="h5" align="center" gutterBottom>
          Login to continue
        </Typography>
        <LoginDialog open={true} onClose={() => {}} />
      </Paper>
    </Box>
  );
};

export default LoginPage;
